module.exports = {
	"textures": [
		{
			"image": "ColdAnimation.png",
			"format": "RGBA8888",
			"size": {
				"w": 2048,
				"h": 2048
			},
			"scale": 1,
			"frames": [
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 394,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 787,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 1180,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 390
					},
					"frame": {
						"x": 1,
						"y": 1573,
						"w": 155,
						"h": 390
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 386
					},
					"frame": {
						"x": 158,
						"y": 1,
						"w": 155,
						"h": 386
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 385
					},
					"frame": {
						"x": 158,
						"y": 389,
						"w": 155,
						"h": 385
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 383
					},
					"frame": {
						"x": 158,
						"y": 776,
						"w": 155,
						"h": 383
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 381
					},
					"frame": {
						"x": 158,
						"y": 1161,
						"w": 155,
						"h": 381
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 381
					},
					"frame": {
						"x": 158,
						"y": 1544,
						"w": 155,
						"h": 381
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 380
					},
					"frame": {
						"x": 315,
						"y": 1,
						"w": 155,
						"h": 380
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 378
					},
					"frame": {
						"x": 315,
						"y": 383,
						"w": 155,
						"h": 378
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 315,
						"y": 763,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 315,
						"y": 1141,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 315,
						"y": 1519,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 375
					},
					"frame": {
						"x": 472,
						"y": 1,
						"w": 155,
						"h": 375
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 374
					},
					"frame": {
						"x": 629,
						"y": 1,
						"w": 155,
						"h": 374
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 374
					},
					"frame": {
						"x": 786,
						"y": 1,
						"w": 155,
						"h": 374
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 374
					},
					"frame": {
						"x": 943,
						"y": 1,
						"w": 155,
						"h": 374
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 374
					},
					"frame": {
						"x": 1100,
						"y": 1,
						"w": 155,
						"h": 374
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 373
					},
					"frame": {
						"x": 1257,
						"y": 1,
						"w": 155,
						"h": 373
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 372
					},
					"frame": {
						"x": 1414,
						"y": 1,
						"w": 155,
						"h": 372
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 372
					},
					"frame": {
						"x": 1571,
						"y": 1,
						"w": 155,
						"h": 372
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 371
					},
					"frame": {
						"x": 1728,
						"y": 1,
						"w": 155,
						"h": 371
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 371
					},
					"frame": {
						"x": 1885,
						"y": 1,
						"w": 155,
						"h": 371
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 370
					},
					"frame": {
						"x": 1728,
						"y": 374,
						"w": 155,
						"h": 370
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 369
					},
					"frame": {
						"x": 1885,
						"y": 374,
						"w": 155,
						"h": 369
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 369
					},
					"frame": {
						"x": 1885,
						"y": 745,
						"w": 155,
						"h": 369
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 366
					},
					"frame": {
						"x": 1414,
						"y": 375,
						"w": 155,
						"h": 366
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 365
					},
					"frame": {
						"x": 1257,
						"y": 376,
						"w": 155,
						"h": 365
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 365
					},
					"frame": {
						"x": 1571,
						"y": 375,
						"w": 155,
						"h": 365
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 362
					},
					"frame": {
						"x": 1571,
						"y": 742,
						"w": 155,
						"h": 362
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 360
					},
					"frame": {
						"x": 1728,
						"y": 746,
						"w": 155,
						"h": 360
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 357
					},
					"frame": {
						"x": 629,
						"y": 377,
						"w": 155,
						"h": 357
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 357
					},
					"frame": {
						"x": 472,
						"y": 378,
						"w": 155,
						"h": 357
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 357
					},
					"frame": {
						"x": 786,
						"y": 377,
						"w": 155,
						"h": 357
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 356
					},
					"frame": {
						"x": 943,
						"y": 377,
						"w": 155,
						"h": 356
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 356
					},
					"frame": {
						"x": 1100,
						"y": 377,
						"w": 155,
						"h": 356
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 352
					},
					"frame": {
						"x": 943,
						"y": 735,
						"w": 155,
						"h": 352
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 350
					},
					"frame": {
						"x": 1100,
						"y": 735,
						"w": 155,
						"h": 350
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 344
					},
					"frame": {
						"x": 1257,
						"y": 743,
						"w": 155,
						"h": 344
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 344
					},
					"frame": {
						"x": 1100,
						"y": 1087,
						"w": 155,
						"h": 344
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 336
					},
					"frame": {
						"x": 1414,
						"y": 743,
						"w": 155,
						"h": 336
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 335
					},
					"frame": {
						"x": 1414,
						"y": 1081,
						"w": 155,
						"h": 335
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 330
					},
					"frame": {
						"x": 1571,
						"y": 1106,
						"w": 155,
						"h": 330
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 330
					},
					"frame": {
						"x": 1728,
						"y": 1108,
						"w": 155,
						"h": 330
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 326
					},
					"frame": {
						"x": 1257,
						"y": 1089,
						"w": 155,
						"h": 326
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 320
					},
					"frame": {
						"x": 1257,
						"y": 1417,
						"w": 155,
						"h": 320
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 316
					},
					"frame": {
						"x": 1414,
						"y": 1418,
						"w": 155,
						"h": 316
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 315
					},
					"frame": {
						"x": 1571,
						"y": 1438,
						"w": 155,
						"h": 315
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:3dd23bb52399f57d0779bb5d6f3df96b:f43c56f78eeab749dd75559936d04450:543e33abecd91ce95178cc520f38a7f3$"
	}
}
;